<template>
  <div class="homeBox">
    <div class="building">
      <el-image :src="imgUrl"></el-image>
    </div>
    <span class="old_ban" @click="qiehuan">切换旧版</span>
    <div class="contentBox">
      <div>HELLO!</div>
      <div>
        <el-image style="width:100%" :src="imgJfy"></el-image>
      </div>
      <div class="formDiv">
        <el-form :model="form">
          <el-form-item class="elInput">
            <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
          </el-form-item>
          <el-form-item class="elInput">
            <el-input v-model="form.password" type="password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <!-- <el-form-item> -->
          <div class="mind">
            <el-checkbox v-model="checked">记住密码</el-checkbox>
          </div>
          <!-- </el-form-item> -->
          <el-form-item class="codeCss">
            <el-input v-model="form.captcha" placeholder="请输入验证码"></el-input>
            <el-button round @click="codeFn">获取验证码</el-button>
            <div>
                    <!-- <img :src="imgCodeUrl" alt="图形验证码" /> -->
                    <img class="imageText" :src="imageText" alt @click="codeFn" />
                    <!-- <el-input></el-input> -->
                    <!-- <VerificationCode :changeCode.sync="identifyCode"></VerificationCode> -->
            </div>
            <!-- <div>验证码</div> -->
          </el-form-item>
          <!-- <el-form-item>
            <el-input v-model="form.name" placeholder="请输入验证码"></el-input>
            <div>验证码</div>
          </el-form-item>-->
          <el-form-item class="loginBtn">
            <div class="tab">
              <div :class="currindex=='2'?'current':''" @click="selecurrent('2')">景区登录</div>
              <div :class="currindex=='1'?'current':''" @click="selecurrent('1')">分销商登录</div>
            </div>
            <el-button round @click="loginFn">登陆</el-button>
          </el-form-item>
        </el-form>
      </div>
    
    </div>
  </div>
</template>

<script>
import {codeGet,signPost,Login} from '@/request/login.js'
export default {
  data() {
    return {
      currindex:'2',
      form: {
        captcha: "",
        password:"",
        username:"",
        key:"",
      },
      imgUrl: require("../images/scenic/login.png"),
      imgJfy: require("../images/scenic/jfy.png"),
      checked: "",
      imageText:""
    };
  },
  created(){
    this.codeFn()
    if(localStorage.getItem('password')){
      const Base64 = require("js-base64").Base64
      this.form.username = localStorage.getItem('username')
      this.form.password = Base64.decode(localStorage.getItem('password')) 
    }
  },
  methods: {
    qiehuan(){
      window.location.href = 'http://home.softykt.net/'
    },
    // 切换状态
    selecurrent(i){
      this.currindex = i
      if(i=='1'){
        if(localStorage.getItem('password1')){
          const Base64 = require("js-base64").Base64
          this.form.username = localStorage.getItem('username1')
          this.form.password = Base64.decode(localStorage.getItem('password1')) 
        }else{
          this.form.username = ''
          this.form.password = '' 
        }
      }else{
        if(localStorage.getItem('password')){
          const Base64 = require("js-base64").Base64
          this.form.username = localStorage.getItem('username')
          this.form.password = Base64.decode(localStorage.getItem('password')) 
        }else{
          this.form.username = ''
          this.form.password = '' 
        }
      }
    },
    // // 获取验证码接口
    codeFn() {
      codeGet().then(res => {
        console.log(res);
        if (res) {
          this.form.key = res.data.url.key;
          this.imageText = res.data.url.img;
        }
      });
    },
    loginFn() {
      // if (num == 11) {
        // this.$router.push("/worke");
      // }
      // if (num == 22) {
        // this.$router.push("/homeFxs");
      // }
     if(this.currindex=='1'){
      signPost(this.form).then(res=>{
        if(res.data.status=='ok'){
          if(res.data.result.permission.length==0){
              this.$message.error('该账号无权限')
              return false
          }
          this.navList = res.data.result.permission;
          window.sessionStorage.setItem("menue", JSON.stringify(this.navList));
          this.$message.success(res.data.msg);
          window.sessionStorage.setItem("Token", res.data.result.token);
          window.sessionStorage.setItem('path',this.$route.path)
          if(this.checked){
            const Base64 = require("js-base64").Base64
            let password = Base64.encode(this.form.password); // base64加密
            localStorage.setItem("username1", this.form.username);
            localStorage.setItem("password1", password);
          }else{
            localStorage.removeItem("username1");
            localStorage.removeItem("password1");
          } 
          this.$router.push("/homeFxs");
        }else{
          this.$message.error(res.data.msg);
        }
      })
     }else{
      Login(this.form).then(res=>{
          if(res.data.status=='ok'){
            if(res.data.data.permission.length==0){
              this.$message.error('该账号无权限')
              return false
            }
            this.navList = res.data.data.permission;
            window.sessionStorage.setItem("menue", JSON.stringify(this.navList));
            this.$message.success(res.data.msg);
            window.sessionStorage.setItem("Token", res.data.data.token);
            window.sessionStorage.setItem('path',this.$route.path)
            if(this.checked){
              const Base64 = require("js-base64").Base64
              let password = Base64.encode(this.form.password); // base64加密
              localStorage.setItem("username", this.form.username);
              localStorage.setItem("password", password);
            }else{
              localStorage.removeItem("username");
              localStorage.removeItem("password");
            }
            window.sessionStorage.setItem("is_pwd", res.data.data.is_pwd);
            this.$router.push("/home");
          }else{
            this.$message.error(res.data.msg);
          }
      })
     }
    }
  }
};
</script>

<style lang='less' scoped>
.tab{
  width: 28.6rem;
  height: 6rem;
  background: #ffffff;
  border:1px solid #666666;
  border-radius: 3rem;
  display: flex;
  margin-bottom: 2rem;
  div{
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666666;
    font-size: 1.6rem;
    cursor: pointer;
  }
  .current{
    border-radius:3rem ;
    background: #246DEB;
    color: #ffffff;
  }
}
.homeBox {
  width: 100%;
  height: 100%;
  position: relative;
  .building {
    width: 100%;
    height: 100%;
    overflow: auto;
    /deep/.el-image {
      width: 100%;
      height: 100%;
    }
  }
  .contentBox {
    width: 640px;
    height: 645px;
    position: absolute;
    top: 100px;
    left: 143px;
    > div:nth-child(1) {
      font-family: "Roboto";
      font-style: normal;
      font-weight: 400;
      font-size: 96px;
      line-height: 112px;
      /* identical to box height */

      color: #666666;
    }
    .formDiv {
      margin-top: 50px;
      .elInput {
        height: 60px;
        margin-bottom: 20px;
        /deep/.el-input {
          width: 550px;
          height: 60px;
          line-height: 60px;
          background: #f7f7fa;
          border-radius: 30px;
        }
        /deep/.el-input__inner {
          width: 550px;
          height: 60px;
          line-height: 60px;
          background: #f7f7fa;
          border-radius: 30px;
          font-family: ".PingFang SC";
          font-style: normal;
          font-weight: 400;
          font-size: 16px;
          line-height: 22px;

          color: #666666;
        }
      }
    }
    .codeCss {
      width: 100%;
      /deep/.el-form-item__content {
        display: flex;
      }
      /deep/.el-input {
        width: 350px;
        height: 60px;
        margin-right: 20px;
      }
      /deep/.el-input__inner {
        width: 350px;
        height: 60px;
        background: #f7f7fa;
        border-radius: 30px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
      }
      /deep/.el-button {
        background: #ffffff;
        border: 1px solid #487cff;
        border-radius: 30px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;

        color: #487cff;
      }
    }
    .loginBtn {
      /deep/.el-button {
        width: 200px;
        height: 60px;
        background: #487cff;
        border-radius: 30px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        /* identical to box height */
        border: none;
        color: #ffffff;
      }
    }
    .mind {
      margin-bottom: 40px;
      margin-left: 50px;
      //   /deep/.el-checkbox__inner {
      //     width: 16px;
      //     height: 16px;
      //   }
      //   /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      //     font-family: ".PingFang SC";
      //     font-style: normal;
      //     font-weight: 400;
      //     font-size: 16px;
      //     color: #333333;
      //   }
    }
  }
}
.imageText {
              width: 162px;
              height: 60px;
              margin-left: 40px;
              
              // border: none;
            }
            .old_ban{
              position: fixed;
              top: 20px;
              right: 20px;
              font-size: 2rem;
              cursor: pointer;
              color: #000000;
            }
            .old_ban:hover{
              color: #246DEB;
            }
</style>